VjsAdmin.Districts = (() => {
    const $table = $('#districts-table');

    const initTable = () => {
        $table.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#districts-table',
            formatNoMatches() {
                const searchTerm = $('.fixed-table-toolbar .search input').val();
                return `No districts ${
                    $('#search-manager option:selected').text() === 'any'
                        ? ''
                        : `managed by <strong>${$('#search-manager option:selected').text()}</strong>, `
                }that have <strong>${$('#search-purchased-for option:selected').text()}${
                    typeof searchTerm !== 'undefined' ? `</strong> matching search term <strong>\`${searchTerm}\`</strong>` : ''
                }`;
            },
            idField: 'district_id',
            sortName: 'district_id',
            sortOrder: 'DESC',
            search_manager: 'any',
            search_purchased_for: '',
            url: Slim.Router.pathFor('districts.list.json'),
            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);
                const table = this;
                const $searchManager = $('#search-manager');
                const $searchPurchasedFor = $('#search-purchased-for');

                $searchManager.off();
                $searchManager.on('change', () => {
                    table.search_manager = $searchManager.find('option:selected').val();
                    table.updateUrl();
                    $('#districts-table').bootstrapTable('refresh');
                });

                if (typeof this.default_search_manager === 'undefined') {
                    this.default_search_manager = this.search_manager;
                }
                this.search_manager = $.urlParam('search_manager') != null ? $.urlParam('search_manager') : this.default_search_manager;
                $searchManager.find(`option[value = "${decodeURIComponent(this.search_manager)}"]`).attr('selected', true);

                $searchPurchasedFor.off();
                $searchPurchasedFor.on('change', () => {
                    table.search_purchased_for = $searchPurchasedFor
                        .find('option:selected')
                        .map((a, item) => item.value)
                        .get()
                        .join(',');
                    table.updateUrl();
                    $('#districts-table').bootstrapTable('refresh');
                });

                if (typeof this.default_search_purchased_for === 'undefined') {
                    this.default_search_purchased_for = this.search_purchased_for;
                }
                this.search_purchased_for = $.urlParam('search_purchased_for') !== null ? $.urlParam('search_purchased_for') : this.default_search_purchased_for;
                $searchPurchasedFor.find(`option[value = "${decodeURIComponent(this.search_purchased_for)}"]`).attr('selected', true);
            },
            updateUrl() {
                const queryParams = {};
                if (this.search_manager !== this.default_search_manager) {
                    queryParams.search_manager = this.search_manager;
                }
                if (this.search_purchased_for !== this.default_search_purchased_for) {
                    queryParams.search_purchased_for = this.search_purchased_for;
                }
                VjsTable.tableDefaults().updateUrl.call(this, queryParams);
            },
            queryParams(params) {
                const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
                myParams.purchased_for = this.search_purchased_for;
                myParams.manager = this.search_manager;
                return myParams;
            },
            columns: [
                {
                    title: 'ID',
                    field: 'district_id',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Purchased?',
                    field: 'purchased',
                    align: 'left',
                    valign: 'middle',
                    sortable: false,
                },
                {
                    title: '<i class="fa fa-user-secret" aria-hidden="true"></i> Manager',
                    field: 'manager',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Salesforce ID',
                    field: 'salesforce_account_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'State',
                    field: 'state_code',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Modified',
                    field: 'date_modified',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: VjsAdmin.dateSorter,
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                },
            ],
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    const row = VjsAdmin.convertDateRow(result, 'MM/DD/YYYY', []);
                    row.is_active = row.active;
                    row.purchased = '';
                    row.platforms.forEach((d) => {
                        if (row[`platform_${d.platform_id}`] === '1') {
                            const url = Slim.Router.pathFor('platforms.districts.licenses.list', {
                                platform_id: d.platform_id,
                                district_joint_guid: row.district_joint_guid,
                            });
                            row.purchased += `<a href="${url}" class = "btn btn-hollow-blue" style = "margin-right: 10px;"><img src="/assets/images/${d.icon_image}" class="platform-icon"/>${d.name}</a>`;
                        }
                    });

                    if (row.salesforce_account_id != null) {
                        row.salesforce_account_id = `<a href="https://pathful.lightning.force.com/lightning/r/Account/${row.salesforce_account_id}/view" target="_blank">${row.salesforce_account_id}&nbsp;<i class="fa fa-external-link" aria-hidden="true"></i></a>`;
                    }

                    if (VjsAdmin.hasPermission('user_management.users.edit.view') && row.manager_employee_id != null) {
                        const managerEditUrl = Slim.Router.pathFor('user_management.users.edit.view', {
                            user_id: row.manager_employee_id,
                        });
                        row.manager = `<a href="${managerEditUrl}" > ${row.manager}</a>`;
                    }

                    if (VjsAdmin.hasPermission('districts.edit.view')) {
                        const districtEditUrl = Slim.Router.pathFor('districts.edit.view', {
                            district_joint_guid: row.district_joint_guid,
                        });
                        row.actions = `<a href="${districtEditUrl}" class="btn btn-hollow-blue"> Edit</a>`;
                    }
                });
                return formattedResult;
            },
        });
    };

    const init = () => {
        initTable();
        $('#search-purchased-for').multiselect({
            numberDisplayed: 1,
            widthSynchronizationMode: 'never',
            buttonWidth: '300px',
            buttonText(options) {
                if (options.length === 0) {
                    return 'Filter by Platform';
                }
                return `${options.length} Platforms Selected`;
            },
        });
    };

    return {
        init,
    };
})();
